/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Fragment, useCallback, useEffect, useState } from 'react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { Button, Table, TableBody, TableContainer, Paper, TablePagination, Box, Grid } from '@mui/material';
import { REQUEST_ACTIONS, sendRequest, setCookie, getCookie } from '../../utils/Communicator';
import { useDispatch, useSelector } from 'react-redux';
import { getSession, setLanguages, onLanguageChange, setPackages, selectPackage } from '../../reducers/requestHandler';
import { snackbarToggle } from '../../reducers/snackbarSlicer';
import { URL, LANGUAGES } from '../../constants/global-constants';
import { Dialog, Snackbar } from '../../style-guide';
import chatSvg from "../../images/homepage/chatIcon.png"
import logo from "../../images/homepage/logo.png"
import RedboxLogo from './../../images/newHomePage/redbox-logo.png';
import facebookWhite from "../../images/homepage/facebook_white.png"
import twitterWhite from "../../images/homepage/twitter_white.png"
import TZUR from "../../images/homepage/TZUR.png"
import '../LandingPage/LandingPage.scss';
import mainBanner from '../../images/redbox_about.jpg';
import certBanner from '../../images/cert.png';
import insta from '../../images/instagram.png'
import facebook from '../../images/facebook.png'
import ActionButton from '../Common/ActionButton';

export const About = ({ setIsRegister }) => {
    const { userInfo } = useSelector(state => state.user);
    const navigate = useNavigate();
    const { snackbar } = useSelector(state => state.snackbar);
    const dispatch = useDispatch();
    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);
    const [isLoaded, setIsLoaded] = useState(true);

    const keyPressed = (e) => {
        if (e.keyCode === 13) {
            //
        }
    }
    const goTo = (e) => {
    }
    useEffect(() => {

    }, [userInfo]);

    const onSnackbarHandleClose = () => { }
    const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    return (
        <Grid lg={12} container justifyContent="center" style={{ direction: "rtl", fontSize: "20px", fontFamily:"Rubik" }}>
            <Grid lg={12} container style={{ maxWidth: "1080px", margin:"20px" }}>
                <Grid lg={12} container item flexDirection="column" alignItems="center" style={{ color:"#FF3452", marginBottom:"70px"}} >
                    <h1>{ `מי אנחנו?`}</h1>
                    {/*<h1><b>redbox</b> p a r c e l</h1>*/}
                </Grid>
                <Grid lg={12} container item style={{  }}>
                    {/*<p>Red Box Parcel מספקת שירות משלוחים הכולל קבלת כתובות בחו"ל ושילוח עד הבית – עם התחייבות למחיר הזול בישראל. החברה שייכת לקבוצת חברות שילוח <a href="http://tclog.co.il/index.php/he/">Total Care Logistics</a> אשר פועלת ברחבי העולם למעלה מ-15 שנה. לקבוצה סניפים בארה"ב, הולנד וישראל.</p>*/}
                    <p><b>RedBox Parcel</b>{ `  היא חברת שילוח ועמילות מכס ישראלית שנולדה מתוך צורך פשוט: לאפשר לכל אחת ואחד מכם להזמין מהאתרים הכי שווים בעולם – גם אם הם לא שולחים לישראל – ולקבל את ההזמנה הביתה, בלי כאב ראש, במחיר משתלם, ובשקיפות מלאה`}</p>
                    <p>{ `אנחנו מספקים לכם כתובות אישיות בארה״ב ובהולנד, כדי שתוכלו להזמין כמעט מכל אתר – ממותגים מובילים ועד מציאות נדירות. מרגע שהחבילה הגיעה אלינו – אנחנו דואגים להכל: שילוח לישראל, שחרור ממכס, והובלה עד הבית או לנקודת הפצה שתבחרו. כל התהליך – באחריות ובשליטה שלנו.`}</p>
                </Grid>
                { /*certificate image*/}
                <Grid lg={12} container item flexDirection="column" alignItems="center" style={{ height: "506px" }}>
                    <img alt="" src={certBanner} width="577" height="790" sizes="(max-width: 577px) 100vw, 577px" style={{ height: "100%", width: "auto" }} />
                </Grid>
                <Grid lg={12} container item style={{}} className="aboutUSRedList" flexDirection="column">
                    <p style={{ color: "#ff3452", fontWeight: "bold", fontSize: "26px" }}>{`מה מייחד אותנו?`}</p> <br/>
                    <ul><li style={{}}>{`אנחנו חברת בלדרות מורשית ומקצועית`}</li></ul>
                    <p style={{ marginRight: "60px" }}>{`יש לנו רישיון רשמי לעמילות מכס ממשרד האוצר ומחלקת עמילות מכס בתוך רדבוקס  – אנחנו לא מעבירים אתכם דרך צד שלישי. כל טיפול בחבילה מתבצע על ידינו, בשקיפות ובדיוק.`}</p>
                    <ul><li>{`אנחנו הכי משתלמים בשוק – באמת`}</li></ul>
                    <p style={{ marginRight: "60px" }}>{`כשהשילוח והעמילות מתבצעים אצלנו, בלי מתווכים – אתם נהנים מהמחיר הכי תחרותי בישראל.`}</p>
                    <ul><li>{`אנחנו מתמחרים בהוגנות לפי 100 גרם`}</li></ul>
                    <p style={{ marginRight: "60px" }}>{`לא תשלמו על אוויר. אם החבילה שלכם שוקלת 1.1 ק"ג – תשלמו על 1.1 ק"ג. אצל אחרים? תשלמו על 1.5 ק"ג.`}</p>
                    <ul><li>{`יש לנו מרכזים לוגיסטיים בבעלות מלאה`}</li></ul>
                    <p style={{ marginRight: "60px" }}>{`בארה״ב ובהולנד – וזה מה שמאפשר לנו לתת שירות מהיר, מדויק, ולענות לכם על כל שאלה מיידית.`}</p>
                    <ul><li>{`אנחנו פה בשבילכם`}</li></ul>
                    <p style={{ marginRight: "60px" }}>{`שירות הלקוחות שלנו זמין, אנושי, מקצועי – ובגובה העיניים. בצ׳אט, במייל או בוואטסאפ – אנחנו פה.`}</p>
                </Grid>

                <Grid lg={12} container item style={{}}>
                    <a href="https://redboxparcel.com/blog?c=publications">
                        <img src={mainBanner} style={{ width: "100%" }} />
                    </a>
                </Grid>
                <Grid lg={12} container item style={{}} flexDirection="column">
                    <p style={{ color: "#ff3452", fontWeight: "bold", fontSize: "26px", marginTop: "40px" }}>{ `חלק מקבוצה בינלאומית`}</p> 
                    <p style={{ }}>{ `Redbox Parcel   היא חברת בת של קבוצת Total Care Logistics  הפועלת מאז 2009 בזירה הבינלאומית ומספקת פתרונות שילוח וניהול לוגיסטי לעסקים ולקוחות פרטיים מכל העולם.`}</p> 
                    <p style={{}}>{ `הקבוצה מפעילה סניפים ומרכזים לוגיסטיים בארה״ב, הולנד וישראל, ומביאה איתה יציבות, ניסיון של שנים, ומערכת ניהול חכמה – מה שמאפשר לנו לספק לכם שירות יוצא דופן, גם כשאתם מזמינים רק פריט אחד קטן.`}</p> 
                    <p style={{ color: "#ff3452", fontWeight: "bold", fontSize: "26px" }}>{ `הצטרפו אלינו`}</p> 
                    <p style={{}}>{ `כבר עשרות אלפי ישראלים מזמינים דרך Redbox – ונהנים מחוויה מהנה, משתלמת ואמינה.`}</p> 
                    <p style={{}}>{ `ההרשמה? חינמית, פשוטה, ולוקחת בדיוק דקה.`}</p> 
                    <p style={{}}>{ `קבלו כתובת אישית, התחילו להזמין – ותנו לנו לדאוג לכל השאר.`}</p> 
                </Grid>
                <Grid lg={12} container item style={{}} flexDirection="column" alignItems="center">
                    <Grid container item style={{maxHeight:"40px", maxWidth:"40%", margin:"40px"}}>
                        <ActionButton onClick={function () {
                            if (userInfo.session) {
                                navigate("/accounts")
                            } else {
                                //setIsLogin(true)
                            }
                        }} textLabel={`הירשמו בחינם`} />
                    </Grid>
                </Grid>
                <Grid lg={12} container item style={{}} flexDirection="column" flexWrap="nowrap">
                    <p>{`ועקבו אחרינו ברשתות החברתיות:`}</p>
                    <Grid lg={12} container item style={{}} flexDirection="row">
                        <img onClick={(e) => {
                            window.location.href = "https://www.instagram.com/redboxparcel";
                            e.preventDefault();
                        }} src={insta} className="img-responsive img-icon" alt="" style={{ cursor: "pointer" }} />
                        <img onClick={(e) => {
                            if (isMobile()) {
                                window.location.href = "fb://page/1522484708046826";
                                setTimeout(function () {
                                    window.location.href = "https://www.facebook.com/redboxparcel?locale=he_IL";
                                },
                                    1000);
                            } else {
                                window.location.href = "https://www.facebook.com/redboxparcel?locale=he_IL";
                                e.preventDefault();
                            }
                        }} src={facebook} className="img-responsive img-icon" alt="" style={{ cursor: "pointer" }} />
                    </Grid>
                </Grid>

            </Grid>
        </Grid>
    );
}

export default About;